import React, { useState, useEffect, useRef } from "react"

//import components
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  CardTitle,
  Container,
  FormFeedback,
  Table,
} from "reactstrap"
import Select from "react-select"
import Dropzone from "react-dropzone"
import { Link, useNavigate, useParams } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"
import {
  fetchPvsDetails,
  updatePvs,
  fetchPvsCategory,
  fetchPvsSubcategory,
  fetchPvsKeyword,
  getPvsDetails,
} from "../../../redux/actions/pvs"
import { getProductList } from "../../../redux/actions/user"
import {
  RESET_PVS_REGISTRATION,
  RESET_UPDATE_PVS_STATE,
} from "../../../redux/types/pvs"
import avatar from "../../../assets/images/users/default-user.png"
import InfoPopup from "components/InfoPopup"
import TagInput from "components/TagInput"
import ImageCropModal from "components/ImageCropModal"
import PageLoader from "components/Common/PageLoader"

const stateOptions = [
  {
    options: [
      {
        label: "Andaman and Nicobar Islands",
        value: 4023,
      },
      {
        label: "Andhra Pradesh",
        value: 4017,
      },
      {
        label: "Arunachal Pradesh",
        value: 4024,
      },
      {
        label: "Assam",
        value: 4027,
      },
      {
        label: "Bihar",
        value: 4037,
      },
      {
        label: "Chandigarh",
        value: 4031,
      },
      {
        label: "Chhattisgarh",
        value: 4040,
      },
      {
        label: "Dadra and Nagar Haveli and Daman and Diu",
        value: 4033,
      },
      {
        label: "Delhi",
        value: 4021,
      },
      {
        label: "Goa",
        value: 4009,
      },
      {
        label: "Gujarat",
        value: 4030,
      },
      {
        label: "Haryana",
        value: 4007,
      },
      {
        label: "Himachal Pradesh",
        value: 4020,
      },
      {
        label: "Jammu and Kashmir",
        value: 4029,
      },
      {
        label: "Jharkhand",
        value: 4025,
      },
      {
        label: "Karnataka",
        value: 4026,
      },
      {
        label: "Kerala",
        value: 4028,
      },
      {
        label: "Ladakh",
        value: 4852,
      },
      {
        label: "Lakshadweep",
        value: 4019,
      },
      {
        label: "Madhya Pradesh",
        value: 4039,
      },
      {
        label: "Maharashtra",
        value: 4008,
      },
      {
        label: "Manipur",
        value: 4010,
      },
      {
        label: "Meghalaya",
        value: 4006,
      },
      {
        label: "Mizoram",
        value: 4036,
      },
      {
        label: "Nagaland",
        value: 4018,
      },
      {
        label: "Odisha",
        value: 4013,
      },
      {
        label: "Puducherry",
        value: 4011,
      },
      {
        label: "Punjab",
        value: 4015,
      },
      {
        label: "Rajasthan",
        value: 4014,
      },
      {
        label: "Sikkim",
        value: 4034,
      },
      {
        label: "Tamil Nadu",
        value: 4035,
      },
      {
        label: "Telangana",
        value: 4012,
      },
      {
        label: "Tripura",
        value: 4038,
      },
      {
        label: "Uttar Pradesh",
        value: 4022,
      },
      {
        label: "Uttarakhand",
        value: 4016,
      },
      {
        label: "West Bengal",
        value: 4853,
      },
    ],
  },
]

const pvsStatusOptions = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "clarification", label: "Clarification" },
]

function EditPvs() {
  document.title = "Edit PVS | PVS | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()
  const { enc_pvs_entry_id } = useParams()

  const [loading, setLoading] = useState(true)
  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [userData, setUserData] = useState()
  const [userPvsData, setUserPvsData] = useState()
  const [selectedAadharFiles, setSelectedAadharFiles] = useState([])
  const [selectedAadharBackFiles, setSelectedAadharBackFiles] = useState([])
  const [selectedPermanentAddressFiles, setSelectedPermanentAddressFiles] =
    useState([])
  const [selectedPuneAddressFiles, setSelectedPuneAddressFiles] = useState([])
  const [selectedBrandLogoFiles, setSelectedBrandLogoFiles] = useState([])
  const [selectedSellerPhotoFiles, setSelectedSellerPhotoFiles] = useState([])
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)
  const [reviewOptions, setReviewOptions] = useState([])
  const [subcategoryOptions, setSubcategoryOptions] = useState([])
  const [imgSrc, setImgSrc] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [currentField, setCurrentField] = useState("")

  const pvsState = useSelector(state => state.pvs)
  const updatePvsState = useSelector(state => state.screens.pvs.updatePvs)
  const token = useSelector(state => state.auth.token)

  // Options for Select
  const keywordOptions = (pvsState.keywordList || []).map(k => ({
    value: k.pvs_key_id,
    label: k.keyword,
  }))

  const categoryOptions = (pvsState.categoryList || []).map(c => ({
    value: c.pvs_cat_id,
    label: c.category,
    encId: c.enc_pvs_cat_id,
  }))

  useEffect(() => {
    dispatch({ type: RESET_PVS_REGISTRATION })
  }, [])

  useEffect(() => {
    if (pvsState.subcategoryList && pvsState.subcategoryList.length > 0) {
      // console.log("in subcategory condition..", subcategoryList)

      let tempSubcategoryOption = []
      pvsState.subcategoryList.map(option => {
        tempSubcategoryOption.push({
          label: option.subcategory,
          value: option.pvs_subcat_id,
          encId: option.enc_pvs_subcat_id,
        })
      })
      // console.log("tempSubcategoryOption:", tempSubcategoryOption)
      setSubcategoryOptions(tempSubcategoryOption)
    }
  }, [pvsState.subcategoryList])

  // Helpers to convert comma-separated strings to objects
  const getObjects = (arr, options) => {
    if (!arr) return []
    if (typeof arr === "string") arr = arr.split(",").map(s => s.trim())
    if (!Array.isArray(arr)) return []
    return arr
      .map(val => options.find(opt => opt.value == String(val)))
      .filter(Boolean)
  }

  const togglePreview = () => setPreviewOpen(!previewOpen)

  const openPreview = file => {
    setPreviewFile(file)
    setPreviewOpen(true)
  }

  const convertUrlToBlob = async (fieldName, filename, url) => {
    const response = await fetch(url)
    const blob = await response.blob()
    const type = blob.type || "image/jpeg"
    const file = new File([blob], filename, { type })

    return {
      file,
      name: file.name,
      type: file.type,
      url: url,
    }
  }

  const onSelectFile = (event, fieldType, withCrop) => {
    console.log("files", event.target.files)

    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }

    if (withCrop) {
      const reader = new FileReader()
      reader.onload = e => {
        setCurrentField(fieldType)
        setImgSrc(e.target.result)
      }
      reader.readAsDataURL(file)
    } else {
      const previewUrl = URL.createObjectURL(file)
      validation.setFieldValue(fieldType, {
        file,
        name: file.name,
        type: file.type,
        url: previewUrl,
      })
    }
  }

  const saveImage = (blob, blobUrl) => {
    console.log("blob..", blob)
    const file = new File([blob], `${currentField}.jpg`, {
      type: blob.type,
      lastModified: Date.now(),
    })
    console.log("file...", file)

    validation.setFieldValue(currentField, {
      name: file.name,
      file: file,
      url: blobUrl,
    })
  }

  const handleFileReupload = (event, fileType) => {
    switch (fileType) {
      case "aadhar_front_img":
        onSelectFile(event, "aadhar_front_img", false)
        break
      case "aadhar_back_img":
        onSelectFile(event, "aadhar_back_img", false)
        break
      case "permanent_address_img":
        onSelectFile(event, "permanent_address_img", false)
        break
      case "pune_address_img":
        onSelectFile(event, "pune_address_img", false)
        break
      case "seller_photo":
        onSelectFile(event, "seller_photo", true)
        break
      case "brand_logo":
        onSelectFile(event, "brand_logo", true)
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (imgSrc) {
      console.log("imgsrc..", imgSrc)
      setIsOpen(true)
    }
  }, [imgSrc])

  // Formik setup
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      fb_url: "",
      seller_name: "",
      seller_email_id: "",
      seller_contact_no: "",
      whatsapp_number: "",
      address: "",
      permanent_address: "",
      team_name: "",
      team_mobile: "",
      team_email: "",
      team_fb_url: "",
      brand_name: "",
      branches: [],
      seller_photo: null,
      brand_logo: null,
      aadhar_front_img: null,
      aadhar_back_img: null,
      permanent_address_img: null,
      pune_address_img: null,
      social_fb_link: "",
      social_insta_link: "",
      social_linkedin_link: "",
      social_gplus_link: "",
      social_website_link: "",
      approval_status: "",
      status: null,
      keywords: [],
      category: null,
      subcategories: [],
      billing_first_name: "",
      billing_last_name: "",
      billing_company_name: "",
      billing_address: "",
      billing_city: "Pune",
      billing_state: stateOptions[0].options[20],
      billing_pincode: "",
      billing_email: "",
      billing_mobile: "",
      billing_gst_number: "",
      remarks: [],
      hasofflinebussiness: false,
    },
    validationSchema: Yup.object({
      fb_url: Yup.string().url("Please enter a valid URL").nullable(),
      seller_name: Yup.string().required("Please Enter Seller Name"),
      seller_email_id: Yup.string()
        .required("Please Enter Seller Email Id")
        .email("Please enter a valid email")
        .nullable(),
      seller_contact_no: Yup.string()
        .required("Please Enter Contact Number")
        .matches(/^\d+$/, "Contact Number must be a valid number"),
      whatsapp_number: Yup.string()
        .required("Please Enter Whatsapp Number")
        .matches(/^\d+$/, "Whatsapp Mobile must be a valid number"),
      team_mobile: Yup.string()
        .matches(/^\d+$/, "Team Mobile must be a valid number")
        .nullable(),
      team_email: Yup.string().email("Please enter a valid email").nullable(),
      team_fb_url: Yup.string().url("Please enter a valid URL").nullable(),
      aadhar_front_img: Yup.mixed(),
      aadhar_back_img: Yup.mixed(),
      permanent_address_img: Yup.mixed(),
      pune_address_img: Yup.mixed(),
      sellerPhoto: Yup.mixed(),
      brandLogo: Yup.mixed(),
      social_fb_link: Yup.string().url("Please enter a valid URL").nullable(),
      social_insta_link: Yup.string()
        .url("Please enter a valid URL")
        .nullable(),
      social_linkedin_link: Yup.string()
        .url("Please enter a valid URL")
        .nullable(),
      social_gplus_link: Yup.string()
        .url("Please enter a valid URL")
        .nullable(),
      social_website_link: Yup.string()
        .url("Please enter a valid URL")
        .nullable(),
      billing_first_name: Yup.string().nullable(),
      billing_last_name: Yup.string().nullable(),
      billing_company_name: Yup.string().nullable(),
      billing_address: Yup.string().nullable(),
      billing_city: Yup.string().nullable(),
      billing_state: Yup.object().nullable(),
      billing_pincode: Yup.string().nullable(),
      billing_email: Yup.string()
        .email("Please enter a valid email")
        .nullable(),
      billing_mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Invalid Mobile Number")
        .nullable(),
      billing_gst_number: Yup.string().nullable(),
      remarks: Yup.array(),
    }),
    onSubmit: values => {
      console.log("values...", values)

      const formData = new FormData()

      // Append text fields
      formData.append("fb_url", values.fb_url)
      formData.append("seller_name", values.seller_name)
      formData.append("seller_email_id", values.seller_email_id)
      formData.append("seller_contact_no", values.seller_contact_no)
      formData.append("whatsapp_number", values.whatsapp_number)
      formData.append("aadhar_card_remark", "")
      formData.append("permanent_address_remark", "")
      formData.append("pune_address_remark", "")
      formData.append("brand_name", values.brand_name)
      formData.append("address", values.address)
      formData.append("branches", values.branches.join(", "))
      formData.append("seller_photo", values.seller_photo.file)
      formData.append("brand_logo", values.brand_logo.file)
      formData.append("aadhar_card_img", values.aadhar_front_img.file)
      formData.append("aadhar_card_img_back", values.aadhar_back_img.file)
      formData.append(
        "permanent_address_img",
        values.permanent_address_img.file
      )
      formData.append("pune_address_img", values.pune_address_img.file)
      formData.append("social_fb_link", values.social_fb_link)
      formData.append("social_insta_link", values.social_insta_link)
      formData.append("social_linkedin_link", values.social_linkedin_link)
      formData.append("social_gplus_link", values.social_gplus_link)
      formData.append("social_website_link", values.social_website_link)
      formData.append("permanent_address", values.permanent_address)
      formData.append("team_name", values.team_name)
      formData.append("team_mobile", values.team_mobile)
      formData.append("team_email", values.team_email)
      formData.append("team_fb_url", values.team_fb_url)
      formData.append("approval_status", values.approval_status)
      if (values.status && values.status.value) {
        formData.append("status", values.status.value)
      } else if (userPvsData && userPvsData.status) {
        formData.append("status", userPvsData.status)
      }
      formData.append("approve", values.status === "approved" ? 1 : 0)

      // Append multi-select fields as CSV
      formData.append("keywords", values.keywords.map(k => k.value).join(","))
      formData.append("remarks", values.remarks.map(r => r.value).join(","))
      formData.append("categories", [values.category.value])
      formData.append(
        "subcategories",
        values.subcategories.map(sc => sc.value).join(",")
      )
      // Append billing details
      formData.append("billing_first_name", values.billing_first_name)
      formData.append("billing_last_name", values.billing_last_name)
      formData.append("billing_company_name", values.billing_company_name)
      formData.append("billing_address", values.billing_address)
      formData.append("billing_city", values.billing_city)
      formData.append(
        "billing_state",
        values.billing_state ? values.billing_state.label : ""
      )
      formData.append("billing_pincode", values.billing_pincode)
      formData.append("billing_email", values.billing_email)
      formData.append("billing_mobile", values.billing_mobile)
      formData.append("billing_gst_number", values.billing_gst_number)

      dispatch(updatePvs(formData, enc_pvs_entry_id))
    },
  })

  useEffect(() => {
    if (userPvsData && userPvsData.categories) {
      const category = categoryOptions.find(
        c => c.value === Number(userPvsData.categories)
      )
      if (category) {
        handleCategoryChange(category.encId)
      }
    }
    if (userPvsData) {
      populateData(userPvsData)
    }
  }, [userPvsData])

  const populateData = async pvsData => {
    let formValues = {
      fb_url: pvsData?.fb_url || "",
      seller_name: pvsData?.seller_name || "",
      seller_email_id: pvsData?.seller_email_id || "",
      seller_contact_no: pvsData?.seller_contact_no || "",
      whatsapp_number: pvsData?.whatsapp_number || "",
      address: pvsData?.address || "",
      permanent_address: pvsData?.permanent_address || "",
      team_name: pvsData?.team_name || "",
      team_mobile: pvsData?.team_mobile || "",
      team_email: pvsData?.team_email || "",
      team_fb_url: pvsData?.team_fb_url || "",
      brand_name: pvsData?.brand_name || "",
      branches: pvsData && pvsData.branches ? pvsData.branches.split(",") : [],
      seller_photo: null,
      brand_logo: null,
      aadhar_front_img: null,
      aadhar_back_img: null,
      permanent_address_img: null,
      pune_address_img: null,
      social_fb_link: pvsData?.social_fb_link || "",
      social_insta_link: pvsData?.social_insta_link || "",
      social_linkedin_link: pvsData?.social_linkedin_link || "",
      social_gplus_link: pvsData?.social_gplus_link || "",
      social_website_link: pvsData?.social_website_link || "",
      approval_status: pvsData?.approval_status || "",
      status:
        pvsData && pvsData.status
          ? pvsStatusOptions.find(s => s.value === pvsData.status)
          : null,
      keywords: getObjects(pvsData?.keywords, keywordOptions),
      category:
        pvsData && pvsData.categories
          ? categoryOptions.find(
              val => val.value === Number(pvsData.categories)
            )
          : null,
      subcategories: getObjects(pvsData?.subcategories, subcategoryOptions),
      billing_first_name: pvsData?.billing_details?.first_name || "",
      billing_last_name: pvsData?.billing_details?.last_name || "",
      billing_company_name: pvsData?.billing_details?.company_name || "",
      billing_address: pvsData?.billing_details?.address || "",
      billing_city: pvsData?.billing_details?.city || "",
      billing_state: pvsData?.billing_details?.state
        ? stateOptions[0].options.find(
            value => value.label === pvsData.billing_details.state
          ) || stateOptions[0].options[20]
        : stateOptions[0].options[20],
      billing_pincode: pvsData?.billing_details?.pincode || "",
      billing_email: pvsData?.billing_details?.email_id || "",
      billing_mobile: pvsData?.billing_details?.mobile_no || "",
      billing_gst_number: pvsData?.billing_details?.gst_number || "",
      remarks: getObjects(pvsData?.remarks, reviewOptions),
      hasofflinebussiness: pvsData?.hasofflinebussiness === 1 ? true : false,
    }
    if (pvsData.aadhar_card_img_path) {
      const aadharFront = await convertUrlToBlob(
        "aadhar_front_img",
        pvsData.aadhar_card_img,
        pvsData.aadhar_card_img_path
      )
      formValues = {
        ...formValues,
        aadhar_front_img: aadharFront,
      }
    }
    if (pvsData.aadhar_card_img_back_path) {
      const aadharBack = await convertUrlToBlob(
        "aadhar_back_img",
        pvsData.aadhar_card_img_back,
        pvsData.aadhar_card_img_back_path
      )
      formValues = {
        ...formValues,
        aadhar_back_img: aadharBack,
      }
    }
    if (pvsData.permanent_address_img_path) {
      const permanentAddressProof = await convertUrlToBlob(
        "permanent_address_img",
        pvsData.permanent_address_img,
        pvsData.permanent_address_img_path
      )
      formValues = {
        ...formValues,
        permanent_address_img: permanentAddressProof,
      }
    }
    if (pvsData.pune_address_img_path) {
      const puneAddressProof = await convertUrlToBlob(
        "pune_address_img",
        pvsData.pune_address_img,
        pvsData.pune_address_img_path
      )
      formValues = {
        ...formValues,
        pune_address_img: puneAddressProof,
      }
    }
    if (pvsData.brand_logo_path) {
      const brandLogo = await convertUrlToBlob(
        "brand_logo",
        pvsData.brand_logo,
        pvsData.brand_logo_path
      )
      formValues = {
        ...formValues,
        brand_logo: brandLogo,
      }
    }
    if (pvsData.seller_photo_path) {
      const sellerPhoto = await convertUrlToBlob(
        "seller_photo",
        pvsData.seller_photo,
        pvsData.seller_photo_path
      )
      formValues = {
        ...formValues,
        seller_photo: sellerPhoto,
      }
    }
    validation.setValues(formValues)
    setLoading(false)
  }

  useEffect(() => {
    console.log("validation..", validation.values)
  }, [validation])

  // Fetch subcategories and products when category changes
  // useEffect(() => {
  //   if (validation.values.category) {
  //     dispatch(
  //       fetchPvsSubcategory({
  //         enc_pvs_cat_id: validation.values.category.encId,
  //       })
  //     )
  //   }
  // }, [validation.values.category])
  const handleCategoryChange = encId => {
    dispatch(
      fetchPvsSubcategory({
        enc_pvs_cat_id: encId,
      })
    )
  }

  // Fetch PVS details and lists on mount
  useEffect(() => {
    if (enc_pvs_entry_id) {
      dispatch(getPvsDetails({ enc_pvs_entry_id }))
      dispatch(fetchPvsCategory())
      dispatch(fetchPvsKeyword())
    }
  }, [dispatch, enc_pvs_entry_id])

  // Set fetched PVS data
  useEffect(() => {
    if (pvsState?.pvsFormData) {
      setUserData(pvsState.pvsFormData)
      setUserPvsData(pvsState.pvsFormData)

      // Set review options
      if (
        pvsState.pvsFormData.review_options &&
        pvsState.pvsFormData.review_options.length > 0
      ) {
        const reviewOptions = pvsState.pvsFormData.review_options.map(item => {
          return {
            value: item.label,
            label: item.label,
          }
        })
        setReviewOptions(reviewOptions)
        if (pvsState.pvsFormData.status === "clarification") {
          let remarksStrArr =
            pvsState.pvsFormData && pvsState.pvsFormData.remarks
              ? pvsState.pvsFormData.remarks.split(",")
              : []
          let tempRemarks = []
          remarksStrArr.forEach(remark => {
            tempRemarks.push({ value: remark, label: remark })
          })
          validation.setFieldValue("remarks", tempRemarks)
        }
      }
    }
  }, [pvsState])

  // Handle update success/error popups
  useEffect(() => {
    if (updatePvsState.success) {
      setSuccessOpen(true)
    } else if (updatePvsState.error) {
      setErrorMsg(updatePvsState.message || "Unable to edit PVS form.")
      setErrorOpen(true)
    }
  }, [updatePvsState, dispatch])

  useEffect(() => {
    if (validation.isSubmitting && validation.errors) {
      let message = (
        <div>
          {/* <h5 className="mb-3">
            Please read the instructions carefully before you upload your
            documents
          </h5> */}
          <ul className="mb-0 ps-3">
            {Object.keys(validation.errors).map(key => (
              <li key={key} className="mb-3">
                {validation.errors[key]}
              </li>
            ))}
          </ul>
        </div>
      )

      console.log("message..", message)

      setErrorMsg(message)
      setErrorOpen(true)
    }
  }, [validation])

  const handleDownload = (url, filename) => {
    fetch(url, { mode: "cors" }) // Fetch the file
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = filename // Set desired filename
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(err => console.error("Download failed:", err))
  }

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch({ type: RESET_UPDATE_PVS_STATE })
          // Redirect based on status
          const status = validation.values.status // or use userPvsData?.status if preferred
          if (status === "approved") {
            history("/pvs", { replace: true })
          } else if (status === "rejected") {
            history("/rejected-pvs", { replace: true })
          } else if (status === "pending") {
            history("/pending-pvs", { replace: true })
          } else {
            history("/pvs", { replace: true }) // fallback
          }
        }}
        message={updatePvsState?.message || "PVS edited successfully!"}
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch({ type: RESET_UPDATE_PVS_STATE }) // reset after closing
        }}
        message={errorMsg}
      />
      <div className="page-content">
        <Container fluid={true}>
          <div className="d-flex align-items-center justify-content-end mt-4 mb-4">
            <div className="flex-grow-1">
              <h4 className="h4 mb-0 nom-title">
                Edit PVS - {validation.values.seller_name}
              </h4>
            </div>
            <Button
              color="primary"
              onClick={() => {
                console.log(userPvsData)
                if (userPvsData && userPvsData.enc_user_id)
                  history(`/view-user/user/${userPvsData.enc_user_id}`)
              }}
            >
              View User
            </Button>
          </div>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <h5 className="nom-title mt-4">Personal Details</h5>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <Label className="form-label" htmlFor="fb_url">
                          Facebook URL
                        </Label>
                        <Input
                          name="fb_url"
                          className="form-control"
                          placeholder="Enter Facebook URL"
                          type="text"
                          id="fb_url"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fb_url}
                          invalid={
                            validation.touched.fb_url &&
                            !!validation.errors.fb_url
                          }
                        />
                        {validation.touched.fb_url &&
                        validation.errors.fb_url ? (
                          <FormFeedback type="invalid">
                            {validation.errors.fb_url}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="col-md-3 align-self-end mb-1">
                        <a
                          href={validation.values.fb_url || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          View Facebook URL
                        </a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="seller_name">
                          Seller Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="seller_name"
                          className="form-control"
                          placeholder="Enter Seller Name"
                          type="text"
                          id="seller_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.seller_name}
                          invalid={
                            validation.touched.seller_name &&
                            !!validation.errors.seller_name
                          }
                        />
                        {validation.touched.seller_name &&
                        validation.errors.seller_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.seller_name}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="seller_email_id">
                          Seller Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="seller_email_id"
                          className="form-control"
                          placeholder="Enter Seller Email"
                          type="email"
                          id="seller_email_id"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.seller_email_id}
                          invalid={
                            validation.touched.seller_email_id &&
                            !!validation.errors.seller_email_id
                          }
                        />
                        {validation.touched.seller_email_id &&
                        validation.errors.seller_email_id ? (
                          <FormFeedback type="invalid">
                            {validation.errors.seller_email_id}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="seller_contact_no"
                        >
                          Seller Contact No{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="seller_contact_no"
                          className="form-control"
                          placeholder="Enter Seller Contact No"
                          type="text"
                          id="seller_contact_no"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.seller_contact_no}
                          invalid={
                            validation.touched.seller_contact_no &&
                            !!validation.errors.seller_contact_no
                          }
                        />
                        {validation.touched.seller_contact_no &&
                        validation.errors.seller_contact_no ? (
                          <FormFeedback type="invalid">
                            {validation.errors.seller_contact_no}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="whatsapp_number">
                          Whatsapp Number <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="whatsapp_number"
                          className="form-control"
                          placeholder="Enter Whatsapp Number"
                          type="text"
                          id="whatsapp_number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.whatsapp_number}
                          invalid={
                            validation.touched.whatsapp_number &&
                            !!validation.errors.whatsapp_number
                          }
                        />
                        {validation.touched.whatsapp_number &&
                        validation.errors.whatsapp_number ? (
                          <FormFeedback type="invalid">
                            {validation.errors.whatsapp_number}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="address">
                          Address
                        </Label>
                        <Input
                          name="address"
                          className="form-control"
                          placeholder="Enter Address"
                          type="text"
                          id="address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address}
                          invalid={
                            validation.touched.address &&
                            !!validation.errors.address
                          }
                        />
                        {validation.touched.address &&
                        validation.errors.address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="permanent_address"
                        >
                          Permanent Address
                        </Label>
                        <Input
                          name="permanent_address"
                          className="form-control"
                          placeholder="Enter Permanent Address"
                          type="text"
                          id="permanent_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.permanent_address}
                          invalid={
                            validation.touched.permanent_address &&
                            !!validation.errors.permanent_address
                          }
                        />
                        {validation.touched.permanent_address &&
                        validation.errors.permanent_address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.permanent_address}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <>
                        <div className="mb-3 col-md-4">
                          <Label className="form-label" htmlFor="team_name">
                            Partner's Name
                          </Label>
                          <Input
                            name="team_name"
                            className="form-control"
                            placeholder="Enter Partner's Name"
                            type="text"
                            id="team_name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.team_name}
                            invalid={
                              validation.touched.team_name &&
                              !!validation.errors.team_name
                            }
                          />
                          {validation.touched.team_name &&
                          validation.errors.team_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.team_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3 col-md-4">
                          <Label className="form-label" htmlFor="team_mobile">
                            Partner's Mobile
                          </Label>
                          <Input
                            name="team_mobile"
                            className="form-control"
                            placeholder="Enter Partner's Mobile"
                            type="text"
                            id="team_mobile"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.team_mobile}
                            invalid={
                              validation.touched.team_mobile &&
                              !!validation.errors.team_mobile
                            }
                          />
                          {validation.touched.team_mobile &&
                          validation.errors.team_mobile ? (
                            <FormFeedback type="invalid">
                              {validation.errors.team_mobile}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3 col-md-4">
                          <Label className="form-label" htmlFor="team_email">
                            Partner's Email
                          </Label>
                          <Input
                            name="team_email"
                            className="form-control"
                            placeholder="Enter Partner's Email"
                            type="email"
                            id="team_email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.team_email}
                            invalid={
                              validation.touched.team_email &&
                              !!validation.errors.team_email
                            }
                          />
                          {validation.touched.team_email &&
                          validation.errors.team_email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.team_email}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-6">
                            <Label className="form-label" htmlFor="fb_url">
                              Partner's Facebook URL
                            </Label>
                            <Input
                              name="team_fb_url"
                              className="form-control"
                              placeholder="Enter Partner's Facebook URL"
                              type="text"
                              id="team_fb_url"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.team_fb_url}
                              invalid={
                                validation.touched.team_fb_url &&
                                !!validation.errors.team_fb_url
                              }
                            />
                            {validation.touched.team_fb_url &&
                            validation.errors.team_fb_url ? (
                              <FormFeedback type="invalid">
                                {validation.errors.team_fb_url}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="col-md-3 align-self-end mb-1">
                            <a
                              href={validation.values.team_fb_url || "#"}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`btn btn-outline-primary ${
                                !validation.values.team_fb_url ||
                                validation.errors.team_fb_url
                                  ? "disabled"
                                  : ""
                              }`}
                              style={{
                                whiteSpace: "nowrap",
                                pointerEvents:
                                  !validation.values.team_fb_url ||
                                  validation.errors.team_fb_url
                                    ? "none"
                                    : "auto",
                              }}
                              onClick={e =>
                                !validation.values.team_fb_url ||
                                (validation.errors.team_fb_url &&
                                  e.preventDefault())
                              }
                              aria-disabled={
                                !validation.values.team_fb_url ||
                                validation.errors.team_fb_url
                              }
                            >
                              View Facebook URL
                            </a>
                          </div>
                        </div>
                      </>
                    </div>

                    <h5 className="nom-title mt-4">Documents</h5>
                    <Table>
                      <tbody>
                        <tr>
                          <th>Aadhar Front</th>
                          <td className="d-flex align-items-center justify-content-end">
                            {validation.values.aadhar_front_img ? (
                              <>
                                <img
                                  src={validation.values.aadhar_front_img.url}
                                  alt="Brand Logo"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.aadhar_front_img.url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    handleDownload(
                                      validation.values.aadhar_front_img.url,
                                      validation.values.aadhar_front_img.name
                                    )
                                  }}
                                >
                                  Download File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-aadhar-front")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-aadhar-front"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "aadhar_front_img")
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Aadhar Back</th>
                          <td className="d-flex align-items-center justify-content-end">
                            {validation.values.aadhar_back_img ? (
                              <>
                                <img
                                  src={validation.values.aadhar_back_img.url}
                                  alt="Brand Logo"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.aadhar_back_img.url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    handleDownload(
                                      validation.values.aadhar_back_img.url,
                                      validation.values.aadhar_back_img.name
                                    )
                                  }}
                                >
                                  Download File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-aadhar-back")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-aadhar-back"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "aadhar_back_img")
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Pune Address Proof</th>
                          <td className="d-flex align-items-center justify-content-end">
                            {validation.values.pune_address_img ? (
                              <>
                                <img
                                  src={validation.values.pune_address_img.url}
                                  alt="Brand Logo"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.pune_address_img.url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    handleDownload(
                                      validation.values.pune_address_img.url,
                                      validation.values.pune_address_img.name
                                    )
                                  }}
                                >
                                  Download File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-pune-address")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-pune-address"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "pune_address_img")
                              }
                            />
                          </td>
                        </tr>

                        <tr>
                          <th>Permanent Address Proof</th>
                          <td className="d-flex align-items-center justify-content-end">
                            {validation.values.permanent_address_img ? (
                              <>
                                <img
                                  src={
                                    validation.values.permanent_address_img.url
                                  }
                                  alt="Brand Logo"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.permanent_address_img
                                        .url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    handleDownload(
                                      validation.values.permanent_address_img
                                        .url,
                                      validation.values.permanent_address_img
                                        .name
                                    )
                                  }}
                                >
                                  Download File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-permanent-address")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-permanent-address"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "permanent_address_img")
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <h5 className="nom-title mt-4">ID Card</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 pb-2">
                          <h6 className="mb-2">
                            Profile Photo{" "}
                            <span style={{ color: "red" }}>*</span>
                          </h6>

                          <div className="row g-3">
                            <div className="col-md-6">
                              <div
                                className="rounded-3 text-center d-flex flex-column align-items-center justify-content-center upload-box-style"
                                onClick={() =>
                                  document
                                    .getElementById("reupload-seller-photo")
                                    .click()
                                }
                              >
                                <i className="mdi mdi-cloud-upload-outline display-6 mb-2"></i>
                                <p className="mb-0 fw-medium">
                                  Click here to upload the file
                                </p>

                                <input
                                  type="file"
                                  id="reupload-seller-photo"
                                  className="d-none"
                                  accept="image/jpeg,image/png,image/jpg"
                                  onChange={e =>
                                    handleFileReupload(e, "seller_photo")
                                  }
                                />
                              </div>

                              {validation.errors.seller_photo && (
                                <div className="text-danger small mt-1">
                                  {validation.errors.seller_photo}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="verifiedcardstyle">
                                <div className="verifiedinner-photobox">
                                  {!validation.values.seller_photo ? (
                                    <i className="mdi mdi-file-image-outline display-6 text-muted"></i>
                                  ) : (
                                    <img
                                      src={validation.values.seller_photo.url}
                                      alt="Profile inside card"
                                      className="verified-innerimage img-fluid"
                                    />
                                  )}
                                </div>
                              </div>

                              {validation.values.seller_photo && (
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      window.open(
                                        validation.values.seller_photo.url,
                                        "_blank"
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-info btn-sm"
                                    onClick={() =>
                                      handleDownload(
                                        validation.values.seller_photo.url,
                                        validation.values.seller_photo.name
                                      )
                                    }
                                  >
                                    Download
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() =>
                                      validation.setFieldValue(
                                        "seller_photo",
                                        null
                                      )
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-4 mt-4">
                          <h6 className="mb-2">
                            Company Logo <span style={{ color: "red" }}>*</span>
                          </h6>

                          <div className="row g-3">
                            <div className="col-md-6">
                              <div
                                className="rounded-3 text-center d-flex flex-column align-items-center justify-content-center upload-box-style"
                                onClick={() =>
                                  document
                                    .getElementById("reupload-brand-logo")
                                    .click()
                                }
                              >
                                <i className="mdi mdi-cloud-upload-outline display-6 mb-2"></i>
                                <p className="mb-0 fw-medium">
                                  Click here to upload the file
                                </p>

                                <input
                                  type="file"
                                  id="reupload-brand-logo"
                                  className="d-none"
                                  accept="image/jpeg,image/png,image/jpg"
                                  onChange={e =>
                                    handleFileReupload(e, "brand_logo")
                                  }
                                />
                              </div>

                              {validation.errors.brand_logo && (
                                <div className="text-danger small mt-1">
                                  {validation.errors.brand_logo}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="verifiedcardstyle">
                                <div className="verifiedinner-photobox">
                                  {!validation.values.brand_logo ? (
                                    <i className="mdi mdi-file-image-outline display-6 text-muted"></i>
                                  ) : (
                                    <img
                                      src={validation.values.brand_logo.url}
                                      alt="Logo inside card"
                                      className="verified-innerimage img-fluid"
                                    />
                                  )}
                                </div>
                              </div>

                              {validation.values.brand_logo && (
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      window.open(
                                        validation.values.seller_photo.url,
                                        "_blank"
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-info btn-sm"
                                    onClick={() =>
                                      handleDownload(
                                        validation.values.brand_logo.url,
                                        validation.values.brand_logo.name
                                      )
                                    }
                                  >
                                    Download
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() =>
                                      validation.setFieldValue(
                                        "brand_logo",
                                        null
                                      )
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <Table>
                      <tbody>
                        <tr>
                          <th>Profile Picture</th>
                          <td className="d-flex align-items-center justify-content-center">
                            {validation.values.seller_photo ? (
                              <>
                                <img
                                  src={validation.values.seller_photo.url}
                                  alt="Profile Picture"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.seller_photo.url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-seller-photo")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-seller-photo"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "seller_photo")
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Brand Logo</th>
                          <td className="d-flex align-items-center justify-content-center">
                            {validation.values.brand_logo ? (
                              <>
                                <img
                                  src={validation.values.brand_logo.url}
                                  alt="Brand Logo"
                                  className="img-fluid me-2"
                                  style={{ maxWidth: "50px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none p-0"
                                  onClick={() => {
                                    window.open(
                                      validation.values.brand_logo.url,
                                      "_blank"
                                    )
                                  }}
                                >
                                  View File
                                </button>
                                <span className="mx-2">|</span>
                              </>
                            ) : (
                              <>
                                <span>NA</span>
                                <span className="mx-2">|</span>
                              </>
                            )}
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none p-0"
                              onClick={() =>
                                document
                                  .getElementById("reupload-brand-logo")
                                  .click()
                              }
                            >
                              Re-upload
                            </button>
                            <input
                              type="file"
                              id="reupload-brand-logo"
                              className="d-none"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={e =>
                                handleFileReupload(e, "brand_logo")
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table> */}
                    <h5 className="nom-title mt-4">Business Details</h5>

                    <div className="form-check mt-4 mb-3">
                      <Input
                        id="offlineStore"
                        name="offlineStore"
                        type="checkbox"
                        className="form-check-input"
                        checked={validation.values.hasofflinebussiness}
                        onChange={() =>
                          validation.setFieldValue(
                            "hasofflinebussiness",
                            !validation.values.hasofflinebussiness
                          )
                        }
                      />
                      <Label htmlFor="checkinput">Has an offline store</Label>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="brand_name">
                          Brand Name
                        </Label>
                        <Input
                          name="brand_name"
                          className="form-control"
                          placeholder="Enter Brand Name"
                          type="text"
                          id="brand_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.brand_name}
                          invalid={
                            validation.touched.brand_name &&
                            !!validation.errors.brand_name
                          }
                        />
                        {validation.touched.brand_name &&
                        validation.errors.brand_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.brand_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="keywords">
                          Keywords
                        </Label>
                        <Select
                          id="keywords"
                          name="keywords"
                          isMulti
                          options={keywordOptions}
                          classNamePrefix="select"
                          placeholder="Type or select keywords..."
                          value={validation.values.keywords || []}
                          onChange={selected =>
                            validation.setFieldValue("keywords", selected)
                          }
                          isClearable
                          isSearchable
                          noOptionsMessage={() => "Type to add new keyword"}
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          }
                          isValidNewOption={() => true}
                        />
                        {validation.touched.keywords &&
                        validation.errors.keywords ? (
                          <FormFeedback type="invalid">
                            {validation.errors.keywords}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="category ">
                          Category
                        </Label>
                        <Select
                          id="category"
                          name="category"
                          options={categoryOptions}
                          classNamePrefix="select"
                          placeholder="Type or select category..."
                          value={validation.values.category || []}
                          onChange={selected => {
                            validation.setFieldValue("category", selected)
                            validation.setFieldValue("subcategories", [])
                            handleCategoryChange(selected.encId)
                          }}
                          isClearable
                          isSearchable
                          noOptionsMessage={() => "Type to add new category"}
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          }
                          isValidNewOption={() => true}
                        />
                        {validation.touched.category &&
                        validation.errors.category ? (
                          <FormFeedback type="invalid">
                            {validation.errors.category}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="subcategories">
                          Subcategories
                        </Label>
                        <Select
                          id="subcategories"
                          name="subcategories"
                          isMulti
                          options={subcategoryOptions}
                          classNamePrefix="select"
                          placeholder="Type or select subcategories..."
                          value={validation.values.subcategories || []}
                          onChange={selected =>
                            validation.setFieldValue("subcategories", selected)
                          }
                          isClearable
                          isSearchable
                          noOptionsMessage={() => "Type to add new subcategory"}
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          }
                          isValidNewOption={() => true}
                        />
                        {validation.touched.subcategories &&
                        validation.errors.subcategories ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subcategories}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 col-md-6">
                        <TagInput
                          title="Branches"
                          // star="*"
                          classNameTag="step-taginp"
                          tags={validation.values.branches}
                          onChange={val =>
                            validation.setFieldValue("branches", val)
                          }
                          buttonTitle="Add"
                          onAddClick={(value, allTags) => {
                            validation.setFieldValue("branches", allTags)
                          }}
                        />
                        {validation.touched.branches &&
                          validation.errors.branches && (
                            <div className="text-danger small mt-1">
                              {validation.errors.branches}
                            </div>
                          )}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="social_fb_link">
                          Facebook Link
                        </Label>
                        <Input
                          name="social_fb_link"
                          className="form-control"
                          placeholder="Enter Facebook Link"
                          type="text"
                          id="social_fb_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.social_fb_link}
                          invalid={
                            validation.touched.social_fb_link &&
                            !!validation.errors.social_fb_link
                          }
                        />
                        {validation.touched.social_fb_link &&
                        validation.errors.social_fb_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.social_fb_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="social_insta_link"
                        >
                          Instagram Link
                        </Label>
                        <Input
                          name="social_insta_link"
                          className="form-control"
                          placeholder="Enter Instagram Link"
                          type="text"
                          id="social_insta_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.social_insta_link}
                          invalid={
                            validation.touched.social_insta_link &&
                            !!validation.errors.social_insta_link
                          }
                        />
                        {validation.touched.social_insta_link &&
                        validation.errors.social_insta_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.social_insta_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="social_linkedin_link"
                        >
                          LinkedIn Link
                        </Label>
                        <Input
                          name="social_linkedin_link"
                          className="form-control"
                          placeholder="Enter LinkedIn Link"
                          type="text"
                          id="social_linkedin_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.social_linkedin_link}
                          invalid={
                            validation.touched.social_linkedin_link &&
                            !!validation.errors.social_linkedin_link
                          }
                        />
                        {validation.touched.social_linkedin_link &&
                        validation.errors.social_linkedin_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.social_linkedin_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="social_gplus_link"
                        >
                          Google+ Link
                        </Label>
                        <Input
                          name="social_gplus_link"
                          className="form-control"
                          placeholder="Enter Google+ Link"
                          type="text"
                          id="social_gplus_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.social_gplus_link}
                          invalid={
                            validation.touched.social_gplus_link &&
                            !!validation.errors.social_gplus_link
                          }
                        />
                        {validation.touched.social_gplus_link &&
                        validation.errors.social_gplus_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.social_gplus_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="social_website_link"
                        >
                          Website Link
                        </Label>
                        <Input
                          name="social_website_link"
                          className="form-control"
                          placeholder="Enter Website Link"
                          type="text"
                          id="social_website_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.social_website_link}
                          invalid={
                            validation.touched.social_website_link &&
                            !!validation.errors.social_website_link
                          }
                        />
                        {validation.touched.social_website_link &&
                        validation.errors.social_website_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.social_website_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <h5 className="nom-title mt-4">Billing Details</h5>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="billing_first_name"
                        >
                          First Name
                        </Label>
                        <Input
                          name="billing_first_name"
                          className="form-control"
                          placeholder="Enter First Name"
                          type="text"
                          id="billing_first_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_first_name}
                          invalid={
                            validation.touched.billing_first_name &&
                            !!validation.errors.billing_first_name
                          }
                        />
                        {validation.touched.billing_first_name &&
                        validation.errors.billing_first_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_first_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="billing_last_name"
                        >
                          Last Name
                        </Label>
                        <Input
                          name="billing_last_name"
                          className="form-control"
                          placeholder="Enter Last Name"
                          type="text"
                          id="billing_last_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_last_name}
                          invalid={
                            validation.touched.billing_last_name &&
                            !!validation.errors.billing_last_name
                          }
                        />
                        {validation.touched.billing_last_name &&
                        validation.errors.billing_last_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_last_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="billing_company_name"
                        >
                          Company Name
                        </Label>
                        <Input
                          name="billing_company_name"
                          className="form-control"
                          placeholder="Enter Company Name"
                          type="text"
                          id="billing_company_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_company_name}
                          invalid={
                            validation.touched.billing_company_name &&
                            !!validation.errors.billing_company_name
                          }
                        />
                        {validation.touched.billing_company_name &&
                        validation.errors.billing_company_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_company_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="billing_email">
                          Email ID
                        </Label>
                        <Input
                          name="billing_email"
                          className="form-control"
                          placeholder="Enter Email ID"
                          type="email"
                          id="billing_email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_email}
                          invalid={
                            validation.touched.billing_email &&
                            !!validation.errors.billing_email
                          }
                        />
                        {validation.touched.billing_email &&
                        validation.errors.billing_email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="billing_mobile">
                          Mobile Number
                        </Label>
                        <Input
                          name="billing_mobile"
                          className="form-control"
                          placeholder="Enter Mobile Number"
                          type="text"
                          id="billing_mobile"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_mobile}
                          invalid={
                            validation.touched.billing_mobile &&
                            !!validation.errors.billing_mobile
                          }
                        />
                        {validation.touched.billing_mobile &&
                        validation.errors.billing_mobile ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_mobile}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="billing_gst_number"
                        >
                          GST Number
                        </Label>
                        <Input
                          name="billing_gst_number"
                          className="form-control"
                          placeholder="Enter GST Number"
                          type="text"
                          id="billing_gst_number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_gst_number}
                          invalid={
                            validation.touched.billing_gst_number &&
                            !!validation.errors.billing_gst_number
                          }
                        />
                        {validation.touched.billing_gst_number &&
                        validation.errors.billing_gst_number ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_gst_number}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-12">
                        <Label className="form-label" htmlFor="billing_address">
                          Address
                        </Label>
                        <Input
                          name="billing_address"
                          className="form-control"
                          placeholder="Enter Address"
                          type="textarea"
                          id="billing_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_address}
                          invalid={
                            validation.touched.billing_address &&
                            !!validation.errors.billing_address
                          }
                        />
                        {validation.touched.billing_address &&
                        validation.errors.billing_address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_address}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="billing_state">
                          State
                        </Label>
                        <Select
                          id="billing_state"
                          name="billing_state"
                          options={stateOptions}
                          classNamePrefix="select"
                          placeholder="Select State"
                          value={validation.values.billing_state}
                          onChange={selected =>
                            validation.setFieldValue("billing_state", selected)
                          }
                          isClearable
                          isSearchable
                        />
                        {validation.touched.billing_state &&
                        validation.errors.billing_state ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_state}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="billing_city">
                          City
                        </Label>
                        <Input
                          name="billing_city"
                          className="form-control"
                          placeholder="Enter City"
                          type="text"
                          id="billing_city"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_city}
                          invalid={
                            validation.touched.billing_city &&
                            !!validation.errors.billing_city
                          }
                        />
                        {validation.touched.billing_city &&
                        validation.errors.billing_city ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_city}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="billing_pincode">
                          Pin Code
                        </Label>
                        <Input
                          name="billing_pincode"
                          className="form-control"
                          placeholder="Enter Pin Code"
                          type="text"
                          id="billing_pincode"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.billing_pincode}
                          invalid={
                            validation.touched.billing_pincode &&
                            !!validation.errors.billing_pincode
                          }
                        />
                        {validation.touched.billing_pincode &&
                        validation.errors.billing_pincode ? (
                          <FormFeedback type="invalid">
                            {validation.errors.billing_pincode}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <h5 className="nom-title mt-4">Application Status</h5>
                    <div className="row">
                      <div className="mb-3 col-md-12">
                        <Label className="form-label" htmlFor="status">
                          Status
                        </Label>
                        <Select
                          id="status"
                          name="status"
                          options={pvsStatusOptions}
                          classNamePrefix="select"
                          placeholder="Select"
                          onChange={val =>
                            validation.setFieldValue("status", val)
                          }
                          value={validation.values.status}
                        />
                        {validation.touched.status &&
                        validation.errors.status ? (
                          <FormFeedback type="invalid">
                            {validation.errors.status}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-12">
                        <Label className="form-label" htmlFor="remarks">
                          Remarks
                        </Label>
                        <Select
                          id="remarks"
                          name="remarks"
                          isMulti
                          options={reviewOptions}
                          classNamePrefix="select"
                          placeholder="Select remarks..."
                          value={validation.values.remarks}
                          onChange={val =>
                            validation.setFieldValue("remarks", val)
                          }
                          onBlur={() =>
                            validation.setFieldTouched("remarks", true)
                          }
                        />
                        {validation.touched.remarks &&
                        validation.errors.remarks ? (
                          <FormFeedback type="invalid">
                            {validation.errors.remarks}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 col-md-12">
                        <Label className="form-label" htmlFor="remarks">
                          Other Remarks
                        </Label>
                        <Input
                          name="approval_status"
                          className="form-control"
                          placeholder="Other Remarks"
                          type="text"
                          id="approval_status"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.approval_status}
                          invalid={
                            validation.touched.approval_status &&
                            !!validation.errors.approval_status
                          }
                        />
                        {validation.touched.approval_status &&
                        validation.errors.approval_status ? (
                          <FormFeedback type="invalid">
                            {validation.errors.approval_status}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    {/* Validation message */}
                    {/* {Object.keys(validation.errors).length > 0 &&
                      Object.keys(validation.touched).length > 0 && (
                        <div className="text-center text-danger mb-2">
                          Please fill all required fields correctly before
                          submitting.
                        </div>
                      )} */}
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        type="submit"
                        color="primary"
                        size="lg"
                        className="mt-3"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <InfoPopup
        size="lg"
        isOpen={previewOpen}
        toggle={togglePreview}
        title="Document Preview"
        previewFile={previewFile}
      />
      <ImageCropModal
        isOpen={isOpen}
        imgSrc={imgSrc}
        saveImage={saveImage}
        toggle={() => setIsOpen(false)}
      />
      <PageLoader open={loading} />
    </React.Fragment>
  )
}

export default EditPvs
